import { eventConstants } from '../constants';

export function events(state = {}, action) {
  switch (action.type) {
    case eventConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case eventConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case eventConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddEvent(state = {}, action) {
  switch (action.type) {
    case eventConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case eventConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case eventConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetEvent(state = {}, action) {
  switch (action.type) {
    case eventConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case eventConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case eventConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateEvent(state = {}, action) {
  switch (action.type) {
    case eventConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case eventConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case eventConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}